<template>
  <div class="base-file-input">
    <div
      class="input-wrapper"
      :class="{ disabled }"
      :style="inputStyle"
      @drop.prevent="changeFile($event, 'drop')"
    >
      <input
        class="input"
        type="file"
        :accept="accept"
        :disabled="disabled"
        @change="changeFile"
      />
      <div class="interface">
        <div class="icon">
          <img
            alt="ファイル読み込みアイコン"
            src="@/assets/images/cloud_upload.png"
            width="40px"
            height="27px"
          />
        </div>
        <div class="label">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFileInput',

  props: {
    accept: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    inputStyle: { type: Object, default: () => ({}) },
    label: { type: String, default: '' }
  },

  methods: {
    changeFile(event, inputType = 'change') {
      const file =
        inputType === 'drop'
          ? event.dataTransfer.files[0]
          : event.target.files[0]
      event.target.value = ''
      this.$emit('input', file)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-file-input {
  > .input-wrapper {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    height: 33px;
    border: dashed 2px #{$gray};
    &.disabled {
      pointer-events: none;
      background: repeating-linear-gradient(
        135deg,
        #a0a0a0,
        #a0a0a0 10px,
        transparent 10px,
        transparent 20px
      );
      opacity: 0.7;
    }
    > .input {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
      &::file-selector-button {
        display: none;
      }
      &:disabled {
        pointer-events: none;
      }
    }
    > .interface {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 10px;
      > .icon {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      > .label {
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        color: #{$gray};
        white-space: pre-wrap;
      }
    }
  }
}
</style>
